// Vendor Libs
import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {createReduxHistoryContext} from 'redux-first-history';
import {createBrowserHistory} from 'history';

// App Reducers
import auth from './auth-reducer';
import updateShelf from './update-shelf-reducer';
import dashboard from './dashboard-reducer';
import formData from './form-data-reducer';
import history from './history-reducer';
import layout from './layout-reducer';
import overlays from './overlay-reducer';
import preferences from './preferences-reducer';
import searchForm from './search-form-reducer';
import servicesSearchData from './services-data-reducer';

export const reduxHistoryContext = createReduxHistoryContext({
    history: createBrowserHistory(),
    routerReducerKey: 'history',
});

const rootReducer = combineReducers({
    auth,
    updateShelf,
    dashboard,
    formData,
    history,
    layout,
    preferences,
    router: routerReducer,
    searchForm,
    servicesSearchData,
    overlays,
});

export default rootReducer;
